import { makeVar, useReactiveVar } from "@apollo/client";
import type { ClientAccessType } from "@shared/graphql.types";

function getClientAccess(): ClientAccessType | undefined {
  if (typeof localStorage === "undefined") return undefined;

  const clientAccess = localStorage.getItem("clientAccess");

  return clientAccess && clientAccess !== "undefined"
    ? JSON.parse(clientAccess)
    : undefined;
}

const clientAccessVar = makeVar<ClientAccessType | undefined>(
  getClientAccess()
);

export function setClientAccess(data: ClientAccessType | undefined): void {
  clientAccessVar(data);

  const clientAccess = clientAccessVar();
  if (typeof localStorage !== "undefined")
    localStorage.setItem("clientAccess", JSON.stringify(clientAccess));
}

export function clearClientAccess(): void {
  setClientAccess(undefined);
  if (typeof localStorage !== "undefined")
    localStorage.removeItem("clientAccess");
}

export function useClientAccess(): ClientAccessType | undefined {
  const clientAccess = useReactiveVar(clientAccessVar);

  return clientAccess;
}
